<div [hidden]="hidden">
    <div [class]="'spinner-overlay'+ (fullScreen ? ' full-screen' : '')">
        <div class="spiner-overlay-inner">
            <div class="text-center spinner-container">
                <mat-progress-spinner [color]="'primary'" [diameter]="diameter" [mode]="mode"
                    [strokeWidth]="strokeWidth" [value]="value"></mat-progress-spinner>
                <div class="spinner-text" *ngIf="text">{{text}}</div>
            </div>
        </div>
    </div>
</div>